import React from 'react';
import LitigationAnalyzer from './components/LitigationAnalyzer';
import './App.css';

function App() {
  return (
    <div className="App">
      <LitigationAnalyzer />
    </div>
  );
}

export default App;